import React from 'react'
import { Cell, Legend, Pie, PieChart, PieLabelRenderProps, Sector, Tooltip } from 'recharts';

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) => {
   if (cx == null || cy == null || innerRadius == null || outerRadius == null) {
      return null;
   }
   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
   const ncx = Number(cx);
   const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
   const ncy = Number(cy);
   const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

   return (
      <text x={x} y={y} fill="white" textAnchor={x > ncx ? 'start' : 'end'} dominantBaseline="central">
         {`${((percent ?? 1) * 100).toFixed(0)}%`}
      </text>
   );
};

const renderCustomLabel = ({ percent, value }: any) => {
   return `${(percent * 100).toFixed(0)}% (${value})`;
};


export default function PieChartWithActive({
   isAnimationActive = true,
   data,
   onSliceClick,
}: {
   data: { name: string; value: number; color: string; code?: string }[];
   isAnimationActive?: boolean;
   onSliceClick?: (entry: { name: string; value: number; code?: string }) => void;
}) {
   const cursor = onSliceClick ? "pointer" : "default";
   return (
      <PieChart width={420} height={420} margin={{ top: 0, right: -20, bottom: 40, left: 120 }}>
         <Pie
            activeShape={{
               fill: '#333333',
            }}
            data={data}
            dataKey="value"
            isAnimationActive={isAnimationActive}
            cx="50%"
            cy="50%"
            outerRadius={100}
            innerRadius={40} // donut style
            paddingAngle={1}
            label={renderCustomLabel}
            onClick={(d: any) => onSliceClick?.(d?.payload || d)}
            style={{ cursor }}
         >
            {data.map((entry: any, index: number) => (
               <Cell key={`cell-${index}`} fill={entry.color} style={{ cursor }} />
            ))}
         </Pie>
         <Tooltip defaultIndex={2} />
         <Legend
            layout="vertical"
            verticalAlign="bottom"
            align="right"
         />
      </PieChart>
   );
}